import * as React from 'react';
import Translate from '../../common/functions/translate';
import { connect } from 'react-redux';

const contentBg =
  <>
    <h2>Какво включва тази политика?</h2>
    <p>За да научите повече за това какво представляват бисквитките и как да ги управлявате, прочетете внимателно настоящата Политика за Бисквитки.</p>

    <h2>Какво представляват бисквитките?</h2>
    <p>Бисквитката представлява малък файл, съдържащ данни, който се съхранява в уеб браузъра на Вашето устройство при посещаване на конкретни уебсайтове. Бисквитките могат да съдържат, но могат и да не съдържат лични данни за посетителя.</p>

    <h2>Защо се използват бисквитките?</h2>
    <p>За да работи правилно, всеки съвременен уебсайт използва бисквитки.</p>
    <p>Те имат различни задачи, които най-общо улесняват и правят по-интерактивно Вашето ползване на уебсайтовете ни.Например, чрез бисквитките събираме информация във връзка с Вашето посещение и поведение на сайта, така че не трябва да ни я предоставяте отново, и отново. По този начин, можем да Ви разпознаем при следващо посещение на уебсайтовете ни и да Ви покажем.</p>
    <p>Бисквитките ни помагат и да разберем как използвате нашите услуги, за да можем непрекъснато да ги подобряваме, чрез персонализиране на съдържанието и предложенията към Вас, на база Вашите предпочитания и интереси.</p>

    <h2>Какви са видовете бисквитки?</h2>
    <p>В зависимост от това колко време се съхраняват на вашето устройство, бисквитките се категоризират на „постоянни” и „временни” („сесийни“) бисквитки.</p>
    <ul>
      <li>„Постоянните” бисквитки се съхраняват на Вашия компютър или мобилно устройство за дълъг период от време, който може да бъде и години;</li>
      <li>„Временните” („сесийните“) бисквитки се поставят временно, когато посещавате уебсайтa, но същите не се съхраняват постоянно на вашето устройство и се заличават, когато Вашата сесия приключи, например като затворите страницата.</li>
    </ul>

    <h2>Какви видове бисквитки използваме и за какви цели?</h2>
    <p>Когато посещавате уебсайтa, вие можете да установите наличието на различни видове бисквитки, които се генерират. Ние използваме и четирите описани типа бисквитки.</p>
    <p>Уебсайтът използва бисквитки за следните цели:</p>
    <ul>
      <li>Идентификация на потребители с цел осъществяване на безопасен достъп;</li>
      <li>Запомняне на продуктите, добавени в кошницата Ви или закупени в процеса на онлайн пазаруването;</li>
      <li>Запазване на предпочитани настройки като например език, местоположение, брой резултати при търсене, които да се визуализират и т.н.;</li>
    </ul>

    <h2>Бисквитки на трети страни:</h2>
    <p>Използваме и някои бисквитки на трети страни като част от нашите услуги. Тези бисквитки се управляват от съответните трети страни и не се контролират от нас.</p>

    <h2>Как да управлявате бисквитките?</h2>
    <p>Вие можете да контролирате и/или да изтривате бисквитките, в зависимост от вашето желание.</p>
    <p>Може да изтриете всички инсталирани на Вашия компютър бисквитки, както и да настроите повечето браузъри така, че да предотвратите разполагането им във Вашия компютър.</p>
    <p>В случай, че направите това, може да е необходимо да правите промени в настройките на някои предпочитания всеки път, когато посещавате уебсайтовете ни, а някои от услугите и функциите на уебсайтовете ни е възможно да не работят.</p>
    <p>Как да изтриете всички бисквитки от даден браузър (показана е информация за най-популярните браузъри):</p>
    <ul>
      <li><a href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=bg">Chrome</a></li>
      <li><a href="https://support.mozilla.org/bg/kb/delete-cookies-remove-info-websites-stored">Firefox</a></li>
      <li><a href="https://support.microsoft.com/bg-bg/help/278835/how-to-delete-cookie-files-in-internet-explorer">Internet Explorer</a></li>
      <li><a href="https://support.apple.com/kb/ph21411?locale=bg_BG">Safari за компютър</a></li>
      <li><a href="Safari за таблет и телефон: https://support.apple.com/bg-bg/HT201265">Safari за таблет и телефон</a></li>
    </ul>

    <h2>Промени в нашата политика за бисквитки</h2>
    <p>Ние си запазваме правото да променяме настоящата Политиката за бисквитки и поради това препоръчваме да преглеждате периодично съдържанието и. Всички бъдещи промени в нашата Политика за бисквитките ще бъдат публикувани на тази страница, от който момент промените ще се считат за влезли в сила, освен ако не е упоменато друго.</p>
    <p>Настоящата политика е актуална към дата 18.09.2019 г.</p>

    <h2>Въпроси и обратна връзка</h2>
    <p>Моля, изпращайте вашите въпроси и коментари относно бисквитките или поверителността на адрес: gdpr@icb.bg</p>

  </>

const contentEn =
  <>
    <h2>What does this policy include?</h2>
    <p>To learn more about what cookies are and how to manage them, read this Cookie Policy carefully.</p>

    <h2>What are cookies?</h2>
    <p>A cookie is a small file containing data that is stored in the web browser of your device when you visit specific websites. Cookies may or may not contain personally identifiable information about the visitor.</p>

    <h2>Why are cookies used?</h2>
    <p>To function properly, any modern website uses cookies.</p>
    <p>They have different tasks that generally facilitate and make your use of our websites more interactive. For example, cookies collect information about your visit and behavior on the site, so you do not have to provide it to us again and again. That way, we can recognize you the next time we visit our websites and show you.</p>
    <p>Cookies also help us understand how you use our services so that we can continually improve them by customizing content and suggestions to you based on your preferences and interests.</p>

    <h2>What are the types of cookies?</h2>
    <p>Depending on how long they are stored on your device, cookies are categorized as "permanent" and "temporary" ("session") cookies.</p>
    <ul>
      <li>Permanent cookies are stored on your computer or mobile device for long periods of time, which can be years;</li>
      <li>Temporary ("session") cookies are placed temporarily when you visit a website, but cookies are not permanently stored on your device and deleted when your session ends, such as by closing a page.</li>
    </ul>

    <h2>What types of cookies do we use and for what purposes?</h2>
    <p>When you visit a website, you may find that different types of cookies are generated. We use all four types of cookies described.</p>
    <p>The website uses cookies for the following purposes:</p>
    <ul>
      <li>Identification of users for safe access;</li>
      <li>Remembering products added to your cart or purchased during the online shopping process;</li>
      <li>Save preferences such as language, location, number of search results to be displayed, etc .;</li>
    </ul>

    <h2>Third-party cookies:</h2>
    <p>We also use some third-party cookies as part of our services. These cookies are managed by the respective third parties and are not controlled by us.</p>

    <h2>How to manage cookies?</h2>
    <p>You can control and / or delete cookies, depending on your preference.</p>
    <p>You can delete all cookies installed on your computer, and set up most browsers to prevent them from being installed on your computer.</p>
    <p>If you do, you may need to make changes to your preferences settings each time you visit our websites, and some of our services and features may not work.</p>
    <p>How to delete all cookies from a browser (shows information for the most popular browsers):</p>
    <ul>
      <li><a href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=bg">Chrome</a></li>
      <li><a href="https://support.mozilla.org/bg/kb/delete-cookies-remove-info-websites-stored">Firefox</a></li>
      <li><a href="https://support.microsoft.com/bg-bg/help/278835/how-to-delete-cookie-files-in-internet-explorer">Internet Explorer</a></li>
      <li><a href="https://support.apple.com/kb/ph21411?locale=bg_BG">Safari за компютър</a></li>
      <li><a href="Safari за таблет и телефон: https://support.apple.com/bg-bg/HT201265">Safari за таблет и телефон</a></li>
    </ul>

    <h2>Changes to our cookie policy</h2>
    <p>We reserve the right to change this Cookie Policy and therefore we recommend that you periodically review its content. Any future changes to our Cookie Policy will be posted on this page, from which time the changes will be considered effective unless is mentioned otherwise.</p>
    <p>This policy is current as of 18.09.2019.</p>

    <h2>Questions and feedback</h2>
    <p>Please send your questions or comments about cookies or privacy to: gdpr@icb.bg</p>

  </>

interface IProps {
  lang: string
}

interface IState {

}

class CookiePolicyComponent extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    let resultHtml;

    switch (this.props.lang) {
      case 'bg':
        resultHtml = contentBg;
        break;
      default:
        resultHtml = contentEn;
    }

    return (
      <div className="app-content">
        <h1>
          {Translate('Cookies Policy')}
        </h1>
        <>
          {resultHtml}
        </>
      </div>
    )
  }

}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang
  };
}

export default connect(mapsStateToProps)(CookiePolicyComponent);